module.exports = __webpack_public_path__ + "static/img/male-5.33ce7854.png";